module.exports = __webpack_public_path__ + "static/gm-10-4401680531cf771d7fd3280c1380da17.jpg";